// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/rest_resource_reservation.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "configd";

/**
 * PortChannel defines a set of server-side interfaces that are bundled into a
 * port channel.
 */
export interface PortChannel {
  /**
   * Server-side interface names (e.g., "Ethernet11_1", "Ethernet11_2").
   * Resolved to switch ports via cabling connections.
   */
  interfaces: string[];
}

/**
 * ServerPortData specifies which servers and interfaces participate in a
 * logical network. Servers are resolved from the reservation-level
 * gpu_server_ids / storage_server_group_ids via the apply flags.
 */
export interface ServerPortData {
  /**
   * port channels on the servers. Each group's interfaces are resolved to
   * switch ports via cabling connections.
   */
  portChannels: PortChannel[];
  /**
   * individual interfaces on the servers. Each interface is resolved to
   * switch ports via cabling connections.
   */
  interfaces: string[];
  /**
   * When true, the interfaces/port_channels in this entry apply to the
   * reservation-level gpu_server_ids.
   */
  applyToGpuServers: boolean;
  /**
   * When true, the interfaces/port_channels in this entry apply to the
   * reservation-level storage_server_group_ids.
   */
  applyToStorageServers: boolean;
  /** Additional server IDs (beyond gpu/storage) to apply to this entry. */
  additionalServerIds: string[];
}

/**
 * VlanMemberPair represents a resolved VNI member as a pairing of switch port
 * and server port, derived from cabling connections.
 */
export interface VlanMemberPair {
  /** The switch node ID. */
  switchNodeId: string;
  /** The switch port name (e.g., "Ethernet1_1" or "PortChannel1"). */
  switchPort: string;
  /** The server node ID. */
  serverNodeId: string;
  /** The server port name (e.g., "Ethernet11_1"). */
  serverPort: string;
}

/** LogicalNetworkReservation represents network parameters for a logical network. */
export interface LogicalNetworkReservation {
  /** The name of the logical network. */
  name: string;
  /** The VNI (VXLAN Network Identifier) for the logical network. */
  vni: number;
  /** The VLAN ID for the logical network (2-3600). */
  vlanId: number;
  /** The anycast gateway IP address for the SVI (e.g., "10.0.0.1/24"). */
  sviIp: string;
  untagged: boolean;
  /**
   * Explicit interface assignments for this logical network. Each entry specifies
   * a set of servers (by node IDs or server group) and which of their interfaces
   * should be added as VNI members.
   * This field is only used in Create/Update requests; it is not returned in GET responses.
   */
  serverPortData: ServerPortData[];
  /**
   * Resolved VLAN members as (switch port, server port) pairs.
   * Populated only in GET responses; ignored in Create/Update requests.
   */
  members: VlanMemberPair[];
}

/** BgpPeerConfig represents BGP peer configuration parameters. */
export interface BgpPeerConfig {
  /** The name or ID of the BGP policy to apply. */
  bgpPolicyId: string;
  /** The IP address of the BGP peer (external router). */
  peerIp: string;
  /** The local ASN (fabric/switch ASN). */
  localAsn: number;
  /** The remote ASN (external router ASN). */
  remoteAsn: number;
  /** The switch node ID where the sub-interface will be created. */
  switchNodeId: string;
  /** The switch port on which the sub-interface will be created. */
  switchPort: string;
  /** The local IP address to assign to the sub-interface (CIDR format). */
  localIp: string;
  /** The VLAN ID used as dot1q encapsulation for the sub-interface. The VLAN ID must be between 1 and 4094. */
  vlanId: number;
}

/** VrfReservation represents a VRF with its associated networks and BGP sessions. */
export interface VrfReservation {
  /** The name of the VRF. */
  name: string;
  /** A label to associate with this VRF. */
  label: string;
  /** The VNI for the L3VNI (required for VXLAN routing). */
  vrfVni: number;
  /** The ASN for BGP peering within this VRF. */
  vrfAsn: number;
  /** Logical networks within this VRF. */
  logicalNetworks: LogicalNetworkReservation[];
  /** BGP peers within this VRF. */
  bgpPeers: BgpPeerConfig[];
}

/**
 * ResourceReservation represents a block of servers reserved for a customer and the network configuration that allows the desired segmentation for these resources
 * for a customer tenant within a fabric.
 */
export interface ResourceReservation {
  /** The fabric ID where this reservation belongs. */
  fabricId: string;
  /** The name of the reservation (customer tenant identifier). */
  name: string;
  /** VRFs associated with this reservation, each with its own networks and BGP sessions. */
  vrfs: VrfReservation[];
  /** Standalone logical networks (not associated with any VRF). */
  logicalNetworks: LogicalNetworkReservation[];
  /** GPU/compute server node IDs included in this reservation. */
  gpuServerIds: string[];
  /** Storage server group IDs included in this reservation. */
  storageServerGroupIds: string[];
}

/** CreateResourceReservationRequest is the request to create a new GPU reservation. */
export interface CreateResourceReservationRequest {
  /** The fabric id or name where the reservation should be created. */
  fabricId: string;
  /**
   * The expected fabric commit identifier (from a prior GET response's commit_id).
   * When provided, the request is rejected with HTTP 409 if the fabric's
   * committed configuration has changed since the client last read it.
   * Pass 0 to skip the check.
   */
  commitId: string;
  /**
   * The expected fabric candidate transaction identifier (from a prior GET response's candidateId).
   * Reserved for future use; currently ignored by the handler.
   */
  candidateId: string;
  /** The GPU reservation configurations to create. */
  reservations: ResourceReservation[];
}

/** CreateResourceReservationResponse is the response after creating a GPU reservation. */
export interface CreateResourceReservationResponse {
  /** The created reservations with populated identifiers. */
  reservations: ResourceReservation[];
}

/** GetResourceReservationsRequest is the request to get a list of GPU reservations. */
export interface GetResourceReservationsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** When true, include resolved VLAN member pairs in each logical network. */
  includeMembers: boolean;
}

/** GetResourceReservationRequest is the request to get a specific GPU reservation. */
export interface GetResourceReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The reservation name. */
  reservationName: string;
  /** When true, include resolved VLAN member pairs in each logical network. */
  includeMembers: boolean;
}

/** GetResourceReservationsResponse is the response containing a list of GPU reservations. */
export interface GetResourceReservationsResponse {
  /** The fabric id or name. */
  fabricId: string;
  /**
   * The fabric's last committed transaction identifier.
   * When candidateId is non-zero, the fabric has pending candidate changes.
   */
  commitId: string;
  /**
   * The fabric's pending candidate transaction identifier.
   * Non-zero only when the fabric has uncommitted candidate changes.
   */
  candidateId: string;
  /** A list of GPU reservations. */
  reservations: ResourceReservation[];
}

/** GetResourceReservationResponse is the response containing a single GPU reservation. */
export interface GetResourceReservationResponse {
  /** The fabric id or name. */
  fabricId: string;
  /**
   * The fabric's last committed transaction identifier.
   * When candidateId is non-zero, the fabric has pending candidate changes.
   */
  commitId: string;
  /**
   * The fabric's pending candidate transaction identifier.
   * Non-zero only when the fabric has uncommitted candidate changes.
   */
  candidateId: string;
  /** The GPU reservation. */
  reservation: ResourceReservation | undefined;
}

/** UpdateResourceReservationRequest is the request to update an existing GPU reservation. */
export interface UpdateResourceReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /**
   * The expected fabric commit identifier (from a prior GET response's commit_id).
   * When provided, the request is rejected with HTTP 409 if the fabric's
   * committed configuration has changed since the client last read it.
   * Pass 0 to skip the check.
   */
  commitId: string;
  /**
   * The expected fabric candidate transaction identifier (from a prior GET response's candidateId).
   * Reserved for future use; currently ignored by the handler.
   */
  candidateId: string;
  /** The name of the reservation to update. */
  reservationName: string;
  /** The updated reservation configuration. */
  reservation: ResourceReservation | undefined;
}

/** DeleteResourceReservationRequest is the request to delete a GPU reservation. */
export interface DeleteResourceReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /**
   * The expected fabric commit identifier (from a prior GET response's commit_id).
   * When provided, the request is rejected with HTTP 409 if the fabric's
   * committed configuration has changed since the client last read it.
   * Pass 0 to skip the check.
   */
  commitId: string;
  /**
   * The expected fabric candidate transaction identifier (from a prior GET response's candidateId).
   * Reserved for future use; currently ignored by the handler.
   */
  candidateId: string;
  /** The reservation name to delete. */
  reservationName: string;
}

function createBasePortChannel(): PortChannel {
  return { interfaces: [] };
}

export const PortChannel: MessageFns<PortChannel> = {
  encode(message: PortChannel, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.interfaces) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortChannel {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortChannel();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.interfaces.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortChannel {
    return {
      interfaces: globalThis.Array.isArray(object?.interfaces)
        ? object.interfaces.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: PortChannel): unknown {
    const obj: any = {};
    if (message.interfaces?.length) {
      obj.interfaces = message.interfaces;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortChannel>, I>>(base?: I): PortChannel {
    return PortChannel.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortChannel>, I>>(object: I): PortChannel {
    const message = createBasePortChannel();
    message.interfaces = object.interfaces?.map((e) => e) || [];
    return message;
  },
};

function createBaseServerPortData(): ServerPortData {
  return {
    portChannels: [],
    interfaces: [],
    applyToGpuServers: false,
    applyToStorageServers: false,
    additionalServerIds: [],
  };
}

export const ServerPortData: MessageFns<ServerPortData> = {
  encode(message: ServerPortData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.portChannels) {
      PortChannel.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.interfaces) {
      writer.uint32(18).string(v!);
    }
    if (message.applyToGpuServers !== false) {
      writer.uint32(24).bool(message.applyToGpuServers);
    }
    if (message.applyToStorageServers !== false) {
      writer.uint32(32).bool(message.applyToStorageServers);
    }
    for (const v of message.additionalServerIds) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerPortData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerPortData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.interfaces.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.applyToGpuServers = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.applyToStorageServers = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.additionalServerIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerPortData {
    return {
      portChannels: globalThis.Array.isArray(object?.portChannels)
        ? object.portChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
      interfaces: globalThis.Array.isArray(object?.interfaces)
        ? object.interfaces.map((e: any) => globalThis.String(e))
        : [],
      applyToGpuServers: isSet(object.applyToGpuServers) ? globalThis.Boolean(object.applyToGpuServers) : false,
      applyToStorageServers: isSet(object.applyToStorageServers)
        ? globalThis.Boolean(object.applyToStorageServers)
        : false,
      additionalServerIds: globalThis.Array.isArray(object?.additionalServerIds)
        ? object.additionalServerIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ServerPortData): unknown {
    const obj: any = {};
    if (message.portChannels?.length) {
      obj.portChannels = message.portChannels.map((e) => PortChannel.toJSON(e));
    }
    if (message.interfaces?.length) {
      obj.interfaces = message.interfaces;
    }
    if (message.applyToGpuServers !== false) {
      obj.applyToGpuServers = message.applyToGpuServers;
    }
    if (message.applyToStorageServers !== false) {
      obj.applyToStorageServers = message.applyToStorageServers;
    }
    if (message.additionalServerIds?.length) {
      obj.additionalServerIds = message.additionalServerIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerPortData>, I>>(base?: I): ServerPortData {
    return ServerPortData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerPortData>, I>>(object: I): ServerPortData {
    const message = createBaseServerPortData();
    message.portChannels = object.portChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    message.interfaces = object.interfaces?.map((e) => e) || [];
    message.applyToGpuServers = object.applyToGpuServers ?? false;
    message.applyToStorageServers = object.applyToStorageServers ?? false;
    message.additionalServerIds = object.additionalServerIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseVlanMemberPair(): VlanMemberPair {
  return { switchNodeId: "", switchPort: "", serverNodeId: "", serverPort: "" };
}

export const VlanMemberPair: MessageFns<VlanMemberPair> = {
  encode(message: VlanMemberPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.switchNodeId !== "") {
      writer.uint32(10).string(message.switchNodeId);
    }
    if (message.switchPort !== "") {
      writer.uint32(18).string(message.switchPort);
    }
    if (message.serverNodeId !== "") {
      writer.uint32(26).string(message.serverNodeId);
    }
    if (message.serverPort !== "") {
      writer.uint32(34).string(message.serverPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VlanMemberPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVlanMemberPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.switchNodeId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.switchPort = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serverNodeId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serverPort = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VlanMemberPair {
    return {
      switchNodeId: isSet(object.switchNodeId) ? globalThis.String(object.switchNodeId) : "",
      switchPort: isSet(object.switchPort) ? globalThis.String(object.switchPort) : "",
      serverNodeId: isSet(object.serverNodeId) ? globalThis.String(object.serverNodeId) : "",
      serverPort: isSet(object.serverPort) ? globalThis.String(object.serverPort) : "",
    };
  },

  toJSON(message: VlanMemberPair): unknown {
    const obj: any = {};
    if (message.switchNodeId !== "") {
      obj.switchNodeId = message.switchNodeId;
    }
    if (message.switchPort !== "") {
      obj.switchPort = message.switchPort;
    }
    if (message.serverNodeId !== "") {
      obj.serverNodeId = message.serverNodeId;
    }
    if (message.serverPort !== "") {
      obj.serverPort = message.serverPort;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VlanMemberPair>, I>>(base?: I): VlanMemberPair {
    return VlanMemberPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VlanMemberPair>, I>>(object: I): VlanMemberPair {
    const message = createBaseVlanMemberPair();
    message.switchNodeId = object.switchNodeId ?? "";
    message.switchPort = object.switchPort ?? "";
    message.serverNodeId = object.serverNodeId ?? "";
    message.serverPort = object.serverPort ?? "";
    return message;
  },
};

function createBaseLogicalNetworkReservation(): LogicalNetworkReservation {
  return { name: "", vni: 0, vlanId: 0, sviIp: "", untagged: false, serverPortData: [], members: [] };
}

export const LogicalNetworkReservation: MessageFns<LogicalNetworkReservation> = {
  encode(message: LogicalNetworkReservation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.vni !== 0) {
      writer.uint32(16).uint32(message.vni);
    }
    if (message.vlanId !== 0) {
      writer.uint32(24).uint32(message.vlanId);
    }
    if (message.sviIp !== "") {
      writer.uint32(34).string(message.sviIp);
    }
    if (message.untagged !== false) {
      writer.uint32(40).bool(message.untagged);
    }
    for (const v of message.serverPortData) {
      ServerPortData.encode(v!, writer.uint32(50).fork()).join();
    }
    for (const v of message.members) {
      VlanMemberPair.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogicalNetworkReservation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLogicalNetworkReservation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.vni = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sviIp = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.untagged = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.serverPortData.push(ServerPortData.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.members.push(VlanMemberPair.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LogicalNetworkReservation {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vni: isSet(object.vni) ? globalThis.Number(object.vni) : 0,
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
      sviIp: isSet(object.sviIp) ? globalThis.String(object.sviIp) : "",
      untagged: isSet(object.untagged) ? globalThis.Boolean(object.untagged) : false,
      serverPortData: globalThis.Array.isArray(object?.serverPortData)
        ? object.serverPortData.map((e: any) => ServerPortData.fromJSON(e))
        : [],
      members: globalThis.Array.isArray(object?.members)
        ? object.members.map((e: any) => VlanMemberPair.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LogicalNetworkReservation): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vni !== 0) {
      obj.vni = Math.round(message.vni);
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    if (message.sviIp !== "") {
      obj.sviIp = message.sviIp;
    }
    if (message.untagged !== false) {
      obj.untagged = message.untagged;
    }
    if (message.serverPortData?.length) {
      obj.serverPortData = message.serverPortData.map((e) => ServerPortData.toJSON(e));
    }
    if (message.members?.length) {
      obj.members = message.members.map((e) => VlanMemberPair.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LogicalNetworkReservation>, I>>(base?: I): LogicalNetworkReservation {
    return LogicalNetworkReservation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LogicalNetworkReservation>, I>>(object: I): LogicalNetworkReservation {
    const message = createBaseLogicalNetworkReservation();
    message.name = object.name ?? "";
    message.vni = object.vni ?? 0;
    message.vlanId = object.vlanId ?? 0;
    message.sviIp = object.sviIp ?? "";
    message.untagged = object.untagged ?? false;
    message.serverPortData = object.serverPortData?.map((e) => ServerPortData.fromPartial(e)) || [];
    message.members = object.members?.map((e) => VlanMemberPair.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBgpPeerConfig(): BgpPeerConfig {
  return {
    bgpPolicyId: "",
    peerIp: "",
    localAsn: 0,
    remoteAsn: 0,
    switchNodeId: "",
    switchPort: "",
    localIp: "",
    vlanId: 0,
  };
}

export const BgpPeerConfig: MessageFns<BgpPeerConfig> = {
  encode(message: BgpPeerConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bgpPolicyId !== "") {
      writer.uint32(10).string(message.bgpPolicyId);
    }
    if (message.peerIp !== "") {
      writer.uint32(18).string(message.peerIp);
    }
    if (message.localAsn !== 0) {
      writer.uint32(24).uint32(message.localAsn);
    }
    if (message.remoteAsn !== 0) {
      writer.uint32(32).uint32(message.remoteAsn);
    }
    if (message.switchNodeId !== "") {
      writer.uint32(42).string(message.switchNodeId);
    }
    if (message.switchPort !== "") {
      writer.uint32(50).string(message.switchPort);
    }
    if (message.localIp !== "") {
      writer.uint32(58).string(message.localIp);
    }
    if (message.vlanId !== 0) {
      writer.uint32(64).uint32(message.vlanId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BgpPeerConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBgpPeerConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bgpPolicyId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.peerIp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.localAsn = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.remoteAsn = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.switchNodeId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.switchPort = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.localIp = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.vlanId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BgpPeerConfig {
    return {
      bgpPolicyId: isSet(object.bgpPolicyId) ? globalThis.String(object.bgpPolicyId) : "",
      peerIp: isSet(object.peerIp) ? globalThis.String(object.peerIp) : "",
      localAsn: isSet(object.localAsn) ? globalThis.Number(object.localAsn) : 0,
      remoteAsn: isSet(object.remoteAsn) ? globalThis.Number(object.remoteAsn) : 0,
      switchNodeId: isSet(object.switchNodeId) ? globalThis.String(object.switchNodeId) : "",
      switchPort: isSet(object.switchPort) ? globalThis.String(object.switchPort) : "",
      localIp: isSet(object.localIp) ? globalThis.String(object.localIp) : "",
      vlanId: isSet(object.vlanId) ? globalThis.Number(object.vlanId) : 0,
    };
  },

  toJSON(message: BgpPeerConfig): unknown {
    const obj: any = {};
    if (message.bgpPolicyId !== "") {
      obj.bgpPolicyId = message.bgpPolicyId;
    }
    if (message.peerIp !== "") {
      obj.peerIp = message.peerIp;
    }
    if (message.localAsn !== 0) {
      obj.localAsn = Math.round(message.localAsn);
    }
    if (message.remoteAsn !== 0) {
      obj.remoteAsn = Math.round(message.remoteAsn);
    }
    if (message.switchNodeId !== "") {
      obj.switchNodeId = message.switchNodeId;
    }
    if (message.switchPort !== "") {
      obj.switchPort = message.switchPort;
    }
    if (message.localIp !== "") {
      obj.localIp = message.localIp;
    }
    if (message.vlanId !== 0) {
      obj.vlanId = Math.round(message.vlanId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BgpPeerConfig>, I>>(base?: I): BgpPeerConfig {
    return BgpPeerConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BgpPeerConfig>, I>>(object: I): BgpPeerConfig {
    const message = createBaseBgpPeerConfig();
    message.bgpPolicyId = object.bgpPolicyId ?? "";
    message.peerIp = object.peerIp ?? "";
    message.localAsn = object.localAsn ?? 0;
    message.remoteAsn = object.remoteAsn ?? 0;
    message.switchNodeId = object.switchNodeId ?? "";
    message.switchPort = object.switchPort ?? "";
    message.localIp = object.localIp ?? "";
    message.vlanId = object.vlanId ?? 0;
    return message;
  },
};

function createBaseVrfReservation(): VrfReservation {
  return { name: "", label: "", vrfVni: 0, vrfAsn: 0, logicalNetworks: [], bgpPeers: [] };
}

export const VrfReservation: MessageFns<VrfReservation> = {
  encode(message: VrfReservation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.vrfVni !== 0) {
      writer.uint32(24).uint32(message.vrfVni);
    }
    if (message.vrfAsn !== 0) {
      writer.uint32(32).uint32(message.vrfAsn);
    }
    for (const v of message.logicalNetworks) {
      LogicalNetworkReservation.encode(v!, writer.uint32(42).fork()).join();
    }
    for (const v of message.bgpPeers) {
      BgpPeerConfig.encode(v!, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VrfReservation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVrfReservation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.vrfVni = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.vrfAsn = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.logicalNetworks.push(LogicalNetworkReservation.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.bgpPeers.push(BgpPeerConfig.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VrfReservation {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      vrfVni: isSet(object.vrfVni) ? globalThis.Number(object.vrfVni) : 0,
      vrfAsn: isSet(object.vrfAsn) ? globalThis.Number(object.vrfAsn) : 0,
      logicalNetworks: globalThis.Array.isArray(object?.logicalNetworks)
        ? object.logicalNetworks.map((e: any) => LogicalNetworkReservation.fromJSON(e))
        : [],
      bgpPeers: globalThis.Array.isArray(object?.bgpPeers)
        ? object.bgpPeers.map((e: any) => BgpPeerConfig.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VrfReservation): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.vrfVni !== 0) {
      obj.vrfVni = Math.round(message.vrfVni);
    }
    if (message.vrfAsn !== 0) {
      obj.vrfAsn = Math.round(message.vrfAsn);
    }
    if (message.logicalNetworks?.length) {
      obj.logicalNetworks = message.logicalNetworks.map((e) => LogicalNetworkReservation.toJSON(e));
    }
    if (message.bgpPeers?.length) {
      obj.bgpPeers = message.bgpPeers.map((e) => BgpPeerConfig.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VrfReservation>, I>>(base?: I): VrfReservation {
    return VrfReservation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VrfReservation>, I>>(object: I): VrfReservation {
    const message = createBaseVrfReservation();
    message.name = object.name ?? "";
    message.label = object.label ?? "";
    message.vrfVni = object.vrfVni ?? 0;
    message.vrfAsn = object.vrfAsn ?? 0;
    message.logicalNetworks = object.logicalNetworks?.map((e) => LogicalNetworkReservation.fromPartial(e)) || [];
    message.bgpPeers = object.bgpPeers?.map((e) => BgpPeerConfig.fromPartial(e)) || [];
    return message;
  },
};

function createBaseResourceReservation(): ResourceReservation {
  return { fabricId: "", name: "", vrfs: [], logicalNetworks: [], gpuServerIds: [], storageServerGroupIds: [] };
}

export const ResourceReservation: MessageFns<ResourceReservation> = {
  encode(message: ResourceReservation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.vrfs) {
      VrfReservation.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.logicalNetworks) {
      LogicalNetworkReservation.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.gpuServerIds) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.storageServerGroupIds) {
      writer.uint32(50).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResourceReservation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResourceReservation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.vrfs.push(VrfReservation.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.logicalNetworks.push(LogicalNetworkReservation.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.gpuServerIds.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.storageServerGroupIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResourceReservation {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      vrfs: globalThis.Array.isArray(object?.vrfs) ? object.vrfs.map((e: any) => VrfReservation.fromJSON(e)) : [],
      logicalNetworks: globalThis.Array.isArray(object?.logicalNetworks)
        ? object.logicalNetworks.map((e: any) => LogicalNetworkReservation.fromJSON(e))
        : [],
      gpuServerIds: globalThis.Array.isArray(object?.gpuServerIds)
        ? object.gpuServerIds.map((e: any) => globalThis.String(e))
        : [],
      storageServerGroupIds: globalThis.Array.isArray(object?.storageServerGroupIds)
        ? object.storageServerGroupIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ResourceReservation): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.vrfs?.length) {
      obj.vrfs = message.vrfs.map((e) => VrfReservation.toJSON(e));
    }
    if (message.logicalNetworks?.length) {
      obj.logicalNetworks = message.logicalNetworks.map((e) => LogicalNetworkReservation.toJSON(e));
    }
    if (message.gpuServerIds?.length) {
      obj.gpuServerIds = message.gpuServerIds;
    }
    if (message.storageServerGroupIds?.length) {
      obj.storageServerGroupIds = message.storageServerGroupIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResourceReservation>, I>>(base?: I): ResourceReservation {
    return ResourceReservation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResourceReservation>, I>>(object: I): ResourceReservation {
    const message = createBaseResourceReservation();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.vrfs = object.vrfs?.map((e) => VrfReservation.fromPartial(e)) || [];
    message.logicalNetworks = object.logicalNetworks?.map((e) => LogicalNetworkReservation.fromPartial(e)) || [];
    message.gpuServerIds = object.gpuServerIds?.map((e) => e) || [];
    message.storageServerGroupIds = object.storageServerGroupIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateResourceReservationRequest(): CreateResourceReservationRequest {
  return { fabricId: "", commitId: "0", candidateId: "0", reservations: [] };
}

export const CreateResourceReservationRequest: MessageFns<CreateResourceReservationRequest> = {
  encode(message: CreateResourceReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.commitId !== "0") {
      writer.uint32(24).int64(message.commitId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(32).int64(message.candidateId);
    }
    for (const v of message.reservations) {
      ResourceReservation.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateResourceReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateResourceReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reservations.push(ResourceReservation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateResourceReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      reservations: globalThis.Array.isArray(object?.reservations)
        ? object.reservations.map((e: any) => ResourceReservation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateResourceReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.reservations?.length) {
      obj.reservations = message.reservations.map((e) => ResourceReservation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateResourceReservationRequest>, I>>(
    base?: I,
  ): CreateResourceReservationRequest {
    return CreateResourceReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateResourceReservationRequest>, I>>(
    object: I,
  ): CreateResourceReservationRequest {
    const message = createBaseCreateResourceReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.commitId = object.commitId ?? "0";
    message.candidateId = object.candidateId ?? "0";
    message.reservations = object.reservations?.map((e) => ResourceReservation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateResourceReservationResponse(): CreateResourceReservationResponse {
  return { reservations: [] };
}

export const CreateResourceReservationResponse: MessageFns<CreateResourceReservationResponse> = {
  encode(message: CreateResourceReservationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reservations) {
      ResourceReservation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateResourceReservationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateResourceReservationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reservations.push(ResourceReservation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateResourceReservationResponse {
    return {
      reservations: globalThis.Array.isArray(object?.reservations)
        ? object.reservations.map((e: any) => ResourceReservation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateResourceReservationResponse): unknown {
    const obj: any = {};
    if (message.reservations?.length) {
      obj.reservations = message.reservations.map((e) => ResourceReservation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateResourceReservationResponse>, I>>(
    base?: I,
  ): CreateResourceReservationResponse {
    return CreateResourceReservationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateResourceReservationResponse>, I>>(
    object: I,
  ): CreateResourceReservationResponse {
    const message = createBaseCreateResourceReservationResponse();
    message.reservations = object.reservations?.map((e) => ResourceReservation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetResourceReservationsRequest(): GetResourceReservationsRequest {
  return { fabricId: "", includeMembers: false };
}

export const GetResourceReservationsRequest: MessageFns<GetResourceReservationsRequest> = {
  encode(message: GetResourceReservationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.includeMembers !== false) {
      writer.uint32(16).bool(message.includeMembers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetResourceReservationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetResourceReservationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeMembers = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetResourceReservationsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      includeMembers: isSet(object.includeMembers) ? globalThis.Boolean(object.includeMembers) : false,
    };
  },

  toJSON(message: GetResourceReservationsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.includeMembers !== false) {
      obj.includeMembers = message.includeMembers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetResourceReservationsRequest>, I>>(base?: I): GetResourceReservationsRequest {
    return GetResourceReservationsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetResourceReservationsRequest>, I>>(
    object: I,
  ): GetResourceReservationsRequest {
    const message = createBaseGetResourceReservationsRequest();
    message.fabricId = object.fabricId ?? "";
    message.includeMembers = object.includeMembers ?? false;
    return message;
  },
};

function createBaseGetResourceReservationRequest(): GetResourceReservationRequest {
  return { fabricId: "", reservationName: "", includeMembers: false };
}

export const GetResourceReservationRequest: MessageFns<GetResourceReservationRequest> = {
  encode(message: GetResourceReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.reservationName !== "") {
      writer.uint32(18).string(message.reservationName);
    }
    if (message.includeMembers !== false) {
      writer.uint32(24).bool(message.includeMembers);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetResourceReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetResourceReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reservationName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMembers = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetResourceReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      reservationName: isSet(object.reservationName) ? globalThis.String(object.reservationName) : "",
      includeMembers: isSet(object.includeMembers) ? globalThis.Boolean(object.includeMembers) : false,
    };
  },

  toJSON(message: GetResourceReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.reservationName !== "") {
      obj.reservationName = message.reservationName;
    }
    if (message.includeMembers !== false) {
      obj.includeMembers = message.includeMembers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetResourceReservationRequest>, I>>(base?: I): GetResourceReservationRequest {
    return GetResourceReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetResourceReservationRequest>, I>>(
    object: I,
  ): GetResourceReservationRequest {
    const message = createBaseGetResourceReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.reservationName = object.reservationName ?? "";
    message.includeMembers = object.includeMembers ?? false;
    return message;
  },
};

function createBaseGetResourceReservationsResponse(): GetResourceReservationsResponse {
  return { fabricId: "", commitId: "0", candidateId: "0", reservations: [] };
}

export const GetResourceReservationsResponse: MessageFns<GetResourceReservationsResponse> = {
  encode(message: GetResourceReservationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    if (message.commitId !== "0") {
      writer.uint32(24).int64(message.commitId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(16).int64(message.candidateId);
    }
    for (const v of message.reservations) {
      ResourceReservation.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetResourceReservationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetResourceReservationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reservations.push(ResourceReservation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetResourceReservationsResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      reservations: globalThis.Array.isArray(object?.reservations)
        ? object.reservations.map((e: any) => ResourceReservation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetResourceReservationsResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.reservations?.length) {
      obj.reservations = message.reservations.map((e) => ResourceReservation.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetResourceReservationsResponse>, I>>(base?: I): GetResourceReservationsResponse {
    return GetResourceReservationsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetResourceReservationsResponse>, I>>(
    object: I,
  ): GetResourceReservationsResponse {
    const message = createBaseGetResourceReservationsResponse();
    message.fabricId = object.fabricId ?? "";
    message.commitId = object.commitId ?? "0";
    message.candidateId = object.candidateId ?? "0";
    message.reservations = object.reservations?.map((e) => ResourceReservation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetResourceReservationResponse(): GetResourceReservationResponse {
  return { fabricId: "", commitId: "0", candidateId: "0", reservation: undefined };
}

export const GetResourceReservationResponse: MessageFns<GetResourceReservationResponse> = {
  encode(message: GetResourceReservationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    if (message.commitId !== "0") {
      writer.uint32(24).int64(message.commitId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(16).int64(message.candidateId);
    }
    if (message.reservation !== undefined) {
      ResourceReservation.encode(message.reservation, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetResourceReservationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetResourceReservationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reservation = ResourceReservation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetResourceReservationResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      reservation: isSet(object.reservation) ? ResourceReservation.fromJSON(object.reservation) : undefined,
    };
  },

  toJSON(message: GetResourceReservationResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.reservation !== undefined) {
      obj.reservation = ResourceReservation.toJSON(message.reservation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetResourceReservationResponse>, I>>(base?: I): GetResourceReservationResponse {
    return GetResourceReservationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetResourceReservationResponse>, I>>(
    object: I,
  ): GetResourceReservationResponse {
    const message = createBaseGetResourceReservationResponse();
    message.fabricId = object.fabricId ?? "";
    message.commitId = object.commitId ?? "0";
    message.candidateId = object.candidateId ?? "0";
    message.reservation = (object.reservation !== undefined && object.reservation !== null)
      ? ResourceReservation.fromPartial(object.reservation)
      : undefined;
    return message;
  },
};

function createBaseUpdateResourceReservationRequest(): UpdateResourceReservationRequest {
  return { fabricId: "", commitId: "0", candidateId: "0", reservationName: "", reservation: undefined };
}

export const UpdateResourceReservationRequest: MessageFns<UpdateResourceReservationRequest> = {
  encode(message: UpdateResourceReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.commitId !== "0") {
      writer.uint32(16).int64(message.commitId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(24).int64(message.candidateId);
    }
    if (message.reservationName !== "") {
      writer.uint32(34).string(message.reservationName);
    }
    if (message.reservation !== undefined) {
      ResourceReservation.encode(message.reservation, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateResourceReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateResourceReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reservationName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.reservation = ResourceReservation.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateResourceReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      reservationName: isSet(object.reservationName) ? globalThis.String(object.reservationName) : "",
      reservation: isSet(object.reservation) ? ResourceReservation.fromJSON(object.reservation) : undefined,
    };
  },

  toJSON(message: UpdateResourceReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.reservationName !== "") {
      obj.reservationName = message.reservationName;
    }
    if (message.reservation !== undefined) {
      obj.reservation = ResourceReservation.toJSON(message.reservation);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateResourceReservationRequest>, I>>(
    base?: I,
  ): UpdateResourceReservationRequest {
    return UpdateResourceReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateResourceReservationRequest>, I>>(
    object: I,
  ): UpdateResourceReservationRequest {
    const message = createBaseUpdateResourceReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.commitId = object.commitId ?? "0";
    message.candidateId = object.candidateId ?? "0";
    message.reservationName = object.reservationName ?? "";
    message.reservation = (object.reservation !== undefined && object.reservation !== null)
      ? ResourceReservation.fromPartial(object.reservation)
      : undefined;
    return message;
  },
};

function createBaseDeleteResourceReservationRequest(): DeleteResourceReservationRequest {
  return { fabricId: "", commitId: "0", candidateId: "0", reservationName: "" };
}

export const DeleteResourceReservationRequest: MessageFns<DeleteResourceReservationRequest> = {
  encode(message: DeleteResourceReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.commitId !== "0") {
      writer.uint32(16).int64(message.commitId);
    }
    if (message.candidateId !== "0") {
      writer.uint32(24).int64(message.candidateId);
    }
    if (message.reservationName !== "") {
      writer.uint32(34).string(message.reservationName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteResourceReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteResourceReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.commitId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.candidateId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reservationName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteResourceReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : "0",
      candidateId: isSet(object.candidateId) ? globalThis.String(object.candidateId) : "0",
      reservationName: isSet(object.reservationName) ? globalThis.String(object.reservationName) : "",
    };
  },

  toJSON(message: DeleteResourceReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.commitId !== "0") {
      obj.commitId = message.commitId;
    }
    if (message.candidateId !== "0") {
      obj.candidateId = message.candidateId;
    }
    if (message.reservationName !== "") {
      obj.reservationName = message.reservationName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteResourceReservationRequest>, I>>(
    base?: I,
  ): DeleteResourceReservationRequest {
    return DeleteResourceReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteResourceReservationRequest>, I>>(
    object: I,
  ): DeleteResourceReservationRequest {
    const message = createBaseDeleteResourceReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.commitId = object.commitId ?? "0";
    message.candidateId = object.candidateId ?? "0";
    message.reservationName = object.reservationName ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
